<template>
<div class="item-list-holder">
  <ul class="item-list">
    <ItemListHeader>
      <span>Name:</span>
      <span>Number Groupings:</span>
      <span>Number Ponies:</span>
      <span>Nickname:</span>
      <span>Start Year</span>
      <span>End Year</span>
    </ItemListHeader>
    <ListItem
      @removed="handleRemove(item.id)"
      :key="item.id"
      v-for="item in items"
      :item="item"
      :user="user"
      model="generation"
      :url="`/generation/${item.id}`"
    >
      <span><router-link :to="`/generation/${item.id}`">{{item.name}}</router-link></span>
      <span>{{item.num_groupings}} {{plural('Grouping', item.num_groupings)}}</span>
      <span>{{item.num_ponies}} {{plural('Ponies', item.num_ponies)}}</span>
      <span>{{item.nickname}}</span>
      <span>{{item.start_year}}</span>
      <span>{{item.end_year}}</span>
    </ListItem>
  </ul>
</div>
</template>

<script>
import { plural } from '../../utils/helpers';

import ListItem from '../../components/ListItem/ListItem';
import ItemListHeader from '../../components/ItemListHeader/ItemListHeader';

export default {
  name: 'GenerationItemList',
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    total: {
      type: Number,
      default: 0,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ItemListHeader,
    ListItem,
  },
  methods: {
    handleRemove(slug) {
      this.$emit('onRemove', slug);
    },
    plural,
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.item-list-holder {
  max-width: $max-width;
  margin-left: auto;
  margin-right: auto;
}

.item-list {
  margin: 0;
  padding: 0;
}
</style>
